<template>
<v-img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTsPJft8UBx3ytTaT-J2M3SkOSmYrAWNp_roA&usqp=CAU" max-width="100px"></v-img>
</template>

<script>
export default {
    name: "rtl"
}
</script>

<style type="text/css" >
.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_0_);}
.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_10_);}
.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#942270;}
.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
</style>